// FIXME: This file is just an example, please take it as reference to make your own.

const routes = {
  authCallback: '/auth/callback',
  root: '/home/:providerId/:id/:orgCode',
  agreementAdjustment: '/adjustment/:id'
}

export default routes
